export async function listObjects(prefix = '') {
  try {
    const r = await fetch(`/api/r2/list?prefix=${encodeURIComponent(prefix)}`);
    if (!r.ok) throw new Error('http');
    return await r.json();
  } catch {
    return [];
  }
}

export async function deleteObject(key) {
  const r = await fetch(`/api/r2/object?key=${encodeURIComponent(key)}`, { method: 'DELETE' });
  if (!r.ok) throw new Error('delete failed');
  return await r.json();
}
